module.exports = __webpack_public_path__ + "static/featuredblock3-11ce3d142a90fbe43016dee03c306481.jpg";